// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PWBfS1ivEgfM_4fO0QUF{margin:0 24px 24px 24px}`, "",{"version":3,"sources":["webpack://./src/entities/Seat/ui/RemoveSeats/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,uBAAA","sourcesContent":[".input {\n  margin: 0 24px 24px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `PWBfS1ivEgfM_4fO0QUF`
};
export default ___CSS_LOADER_EXPORT___;
